import axios from './ajax'

var http = {}
http.getBanner = async()=> {
  const data = await axios.get('/public/picture/banner.do')
  return data.data
}
//获取验证码
http.verifyCode = async (mobile,type)=> {
  const data = await axios.get('/public/init/verifyCode.do',{
    params: {
      mobile,
      type
    }
  })
  return data.data
}
//注册
http.register = async (mobile,verifyCode,password,from)=> {
  const data = await axios.get('/public/init/register.do',{
    params: {
      mobile,
      verifyCode,
      password,
      from
    }
  })
  return data.data
}
//登录
http.login = async (account,password,type) => {
  const data = await axios.get('/public/init/login.do',{
    params: {
      account,
      password
    }
  })
  return data.data
}
//登出
http.logout = async ()=> {
  const data = await axios.get('/public/init/logout.do')
  return data.data
}
//获取登录状态
http.loginState = async ()=> {
  const data = await axios.get('/public/init/loginState.do')
  return data.data
}
//参赛产品信息
http.productList = async (productInfo)=> {
  const data = await axios.post('/private/enroll/proBaoming.do',productInfo)
  return data.data
}
//问卷调查
http.surveyPager = async (paperId)=> {
  const data =await axios.get('/private/enroll/surveyPaper.do',{
    params: {
      paperId
    }
  })
  return data.data
}

//答题
http.saveAnswer = async (questionId,answerIds)=> {
  const data = await axios.get('/private/enroll/saveAnswer.do',{
    params: {
      questionId,
      answerIds
    }
  })
  return data.data
}
//问卷提交
http.surveySubmit = async (paperId) => {
  const data = await axios.get('/private/enroll/surveySubmit.do',{
    params:{
      paperId
    }
  })
  return data.data
}
//管理人信息
http.institut = async (managerInfo) => {
  const data = await axios.post('/private/enroll/institut.do',managerInfo)
  return data.data
}

//修改登录密码
http.changePassword = async (pwd,newPwd)=> {
  const data = await axios.get('/private/personal/changePassword.do',{
    params: {
      pwd,
      newPwd
    }
  })
  return data.data
}
//更改绑定手机号
http.changeMobile = async (mobile,verifyCode)=> {
  const data = await axios.get('/private/personal/changeMobile.do',{
    params: {
      mobile,
      verifyCode
    }
  })
  return data.data
}
//基本信息
http.basicInfo = async ()=> {
  const data = await axios.get('/private/personal/basicInfo.do')
  return data.data
}
//净值查看
http.queryJz = async () => {
  const data = await axios.get('/private/personal/queryJz.do')
  return data.data
}
//净值填报
http.jzSubmit = async(jzInfo) => {
  const data = await axios.post('/private/personal/jzSubmit.do',jzInfo)
  return data.data
}
//净值填报判断
http.jzBeforeSub = async ()=> {
  const data = await axios.get('/private/personal/jzBeforeSub.do')
  return data.data
}
//净值填报方式修改
http.subTypeSubmit = async (typeInfo) => {
  const data = await axios.post('/private/personal/subTypeSubmit.do',typeInfo)
  return data.data
}
//净值填报方式修改产品列表
http.submitList = async ()=> {
  const data = await axios.get('/private/personal/submitList.do')
  return data.data
}
//文件上传
http.upload=async (file)=> {
  const data = await axios.post('/file/upload.do',file)
  return data.data
}
//新闻公告列表
http.newslist=async (index,size)=> {
  const data = await axios.get('/public/news/list.do',{
    params:{
      index,
      size
    }
  })
  return data.data
}
//详情
http.newsDetail=async (newsId)=> {
  const data = await axios.get('/public/news/newsDetail.do',{
    params:{
      newsId
    }
  })
  return data.data
}
//排行榜
http.ranklist=async (productName,institutName,groupService,orderValue,orderType,index,size)=> {
  const data = await axios.get('/public/ranking/list.do',{
    params:{
      productName,
      institutName,
      groupService,
      orderValue,
      orderType,
      index,
      size
    }
  })
  return data.data
}
http.ranklistPC=async (productName,institutName,groupService,orderValue,orderType,index,size)=> {
  const data = await axios.get('/private/ranking/list.do',{
    params:{
      productName,
      institutName,
      groupService,
      orderValue,
      orderType,
      index,
      size
    }
  })
  return data.data
}
// 大赛排行
http.season=async (productName,institutName,groupService,orderValue,orderType,index,size)=> {
  const data = await axios.get('/private/ranking/season.do',{
    params:{
      productName,
      institutName,
      groupService,
      orderValue,
      orderType,
      index,
      size
    }
  })
  return data.data
}
// 大赛排行搜索
http.seasonPreciseQuery=async (productName,institutName,groupService,orderValue,orderType,index,size)=> {
  const data = await axios.get('/private/ranking/seasonPreciseQuery.do',{
    params:{
      productName,
      institutName,
      groupService,
      orderValue,
      orderType,
      index,
      size
    }
  })
  return data.data
}
//产品详情
http.proDetail=async (productId) => {
  const data = await axios.get('/private/ranking/proDetail.do',{
    params: {
      productId
    }
  })
  return data.data
}
// 蓝色档案
http.proSeries=async (productId) => {
  const data = await axios.get('/private/ranking/proSeries.do',{
    params: {
      productId
    }
  })
  return data.data
}

//找回密码
http.cbPassword=async (mobile,verifyCode)=> {
  const data = await axios.get('/public/init/cbPassword.do',{
    params: {
      mobile,
      verifyCode
    }
  })
  return data.data
}
http.changeToLhmj=async()=> {
  const data = await axios.get('/private/personal/changeToLhmj.do',{
    params:{
    }
  })
  return data.data
}
export {
  http
}
//上赛季排行榜
http.prevrank=async (productName,institutName,groupService,orderValue,orderType,index,size)=> {
  const data = await axios.get('/private/his/ranking/list.do',{
    params:{
      productName,
      institutName,
      groupService,
      orderValue,
      orderType,
      index,
      size
    }
  })
  return data.data
}
// 历届排行
http.prevranking=async (productName,institutName,groupService,orderValue,orderType,index,size,series)=> {
  const data = await axios.get('/prev/ranking/list.do',{
    params:{
      productName,
      institutName,
      groupService,
      orderValue,
      orderType,
      index,
      size,
      series
    }
  })
  return data.data
}
// 上赛季产品详情
http.proDetailPrev=async (productId,series) => {
  const data = await axios.get('/prev/ranking/proDetailBySeries.do',{
    params: {
      productId,
      series
    }
  })
  return data.data
}
// 联系人信息更改
http.changeLinkmanInfo = async(linkmanVo) => {
  const data = await axios.post('/private/personal/changeLinkmanInfo.do',linkmanVo)
  return data.data
}
// 产品退赛
http.signOutProducts = async(ids) => {
  const data = await axios.post('/private/personal/signOutProducts.do',ids)
  return data.data
}

// 注销按钮显示
http.judgeProBaoming=async (mobile) => {
  const data = await axios.get('/private/enroll/judgeProBaoming.do',{
    params: {
      mobile
    }
  })
  return data.data
}
// 注销账号
http.cancelAccount=async () => {
  const data = await axios.get('/private/personal/cancelAccount.do')
  return data.data
}


// WEBPACK FOOTER //
// ./src/fetch/api.js